import { toProduct } from '@shared/shop-api/product/mapper'
import { toProductVariant } from '@shared/shop-api/product/variants/mapper'
import type { ProductWithVariantsFragment } from '@shared/types/storefront/graphql'

export const toProductWithVariants = (product: ProductWithVariantsFragment) => {
  return {
    ...toProduct(product),
    variants: product.variants.items.map(toProductVariant),
    variantsCount:
      product.variantsCount?.count ?? product.variants.items.length,
  }
}
